import React,{ useContext, useState,useEffect } from "react";
import { store } from "../store";
import { useNavigate } from "react-router-dom";
import { appLogout } from "../component/custom";
import { TextInput,Text } from 'react-native-web';
import { format, parse,isValid,subYears } from 'date-fns'


export const Page5 = () => {
  const { globalState, dispatch } = useContext(store)
  const navigate = useNavigate()
  const [text, setText] = useState(format(new Date(), 'dd/MM/yyyy'));
  const [dateTime,setDateTime] = useState();

  useEffect(() => {
    const tmpDateTime = parse(text, 'dd/MM/yyyy', new Date());
    console.log('tmpDateTime', tmpDateTime);
    if (isValid(tmpDateTime) && text.length==10) {
      setDateTime(tmpDateTime)
    }
  }, [text])

  return (
    <div style={{ display: 'flex', flexDirection: 'column', paddingLeft: 20, paddingTop: 20 }}>
      <div>Page5</div>
      <TextInput
        style={{ width: 200, height: 40, backgroundColor: 'white' }}
        value={text}
        onChangeText={text => setText(prev => getDateOutput(prev, text))}
      />
      <Text>{JSON.stringify(dateTime)}</Text>
      <Text>{format(subYears(dateTime,543),'yyyy-MM-dd')}</Text>
    </div>
  )
}

function getDateOutput(prev, text) {
  let tmpString = text.split('');
  if (tmpString.length > 10) return prev;
  console.log('length:' + tmpString.length + ':' + text.length);

  try {
    if (prev?.length < text?.length) {
      if (text.length == 2) {
        tmpString.splice(2, 0, '/')
      } else if (text.length >= 2 && tmpString.length >= 3 && tmpString[2] != '/') {
        tmpString.splice(2, 0, '/')
      } else if (text.length == 5) {
        tmpString.splice(5, 0, '/')
      } else if (text.length >= 4 && tmpString.length >= 6 && tmpString[5] != '/') {
        tmpString.splice(5, 0, '/')
      }
    } else if (prev?.length > text?.length) {
      if (text.length == 3) {
        tmpString.splice(2, 1);
      }
      if (text.length == 6) {
        tmpString.splice(5, 1);
      }
    }
  } catch (e) {
    return prev;
  }
  return tmpString.join('');
}
